import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import {
    Box, TextField, Button, Typography, Paper, MenuItem, Select,
    CircularProgress, Container, FormHelperText, FormControl, InputLabel,
    Checkbox
} from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ClearIcon from '@mui/icons-material/Clear';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { LobService } from '../services/lobService';
import Swal from 'sweetalert2';
import Cookies from 'universal-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetTabState } from '../Redux/TabDucks';
import { LogoutUser } from '../Redux/UsersDucks';
import { ValidarRut, ValidarEmail } from '../Utilities/ValidarRut';
import { SearchService } from '../services/SearchService';
import { DesbloqueoService } from '../services/DesbloqueoService';
import { CreditorService } from '../services/creditorService';
import { formatToCLP } from '../services/monedaService';//'../services/monedaService';
import { setCrearHojaEntrevista } from '../Redux/V2/ContratoRedux'
import moment from 'moment';
import { use } from 'react';
import ContratoPage from "./ContratoPage";
import HourglassTopTwoToneIcon from '@mui/icons-material/HourglassTopTwoTone';
import { X } from 'lucide-react';

const ClientesBusqueda = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const entrevista = useSelector((store) => store.contratoV2.Entrevista)

    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useState({ rutPasaporte: '', email: '', searchType: 'RUT/Pasaporte', entityType: '', data: '' });
    const [hubspotResults, setHubspotResults] = useState(null);
    const [error, setError] = useState(null);
    const [baja, setBaja] = useState(false);
    const [negocioList, setNegocioList] = useState([]);
    const [selectedNegocio, setSelectedNegocio] = useState('');
    const [userRolId, setUserRolId] = useState(null);
    const [searching, setSearching] = useState(false);


    const today = new Date();
    const cookies = new Cookies();
    const usuarioSolicitante = cookies.get('userId') || 'Usuario Desconocido';

    // Obtener el rol del usuario desde las cookies al montar el componente
    useEffect(() => {
        const rolId = cookies.get('rolId');
        if (rolId) setUserRolId(parseInt(rolId, 10));
    }, []);

    // Cargar lista de líneas de negocio al montar el componente
    useEffect(() => {
        const fetchNegocios = async () => {
            try {
                const negocios = await CreditorService.getLineaNegocio();
                // La condición ahora se evaluará con el userRolId correcto
                if (userRolId === 4) {
                    const filteredNegocios = negocios.filter(negocio => negocio.id === 4);
                    setNegocioList(filteredNegocios);
                } else {
                    setNegocioList(negocios);
                }
            } catch (err) {
                setNegocioList([]);
            }
        };

        // La lógica de fetchNegocios se ejecuta solo si userRolId no es null
        if (userRolId !== null) {
            fetchNegocios();
        }
    }, [userRolId]);

    // Validación de sesión/cookies y rol
    useEffect(() => {
        dispatch(resetTabState());
        const cookies = new Cookies();
        const exp = cookies.get('expirationTime');
        const expirationTime = typeof exp === "number" ? exp * 1000 : new Date(exp).getTime();

        if (expirationTime && Date.now() >= expirationTime) {
            dispatch(LogoutUser());
            navigate("/");
            return;
        }
        if (!cookies.get('identifier')) {
            dispatch(LogoutUser());
            navigate("/");
        }
    }, []);


    const handleSearchB = async () => {
        setHubspotResults([]);
        sessionStorage.removeItem("customerInterviewId");

        const searchType = searchParams.searchType;
        let data = searchParams.data;
        const rawData = searchParams.data || '';
        var identifierValue = rawData.trim();

        // Validaciones básicas
        if (searchType === 'RUT/Pasaporte') {
            data = ValidarRut(data);
            if (!data) {
                Swal.fire({ position: "center", icon: "error", title: "Rut Invalido.", showConfirmButton: false, timer: 4500 });
                return;
            }
        } else if (searchType === 'Correo') {
            if (!ValidarEmail(data)) {
                Swal.fire({ position: "center", icon: "error", title: "Correo Invalido.", showConfirmButton: false, timer: 4500 });
                return;
            }
        }

        dispatch(resetTabState());
        setLoading(true);
        setSearching(true);  // ⬅️ activa reloj en botón
        setError(null);


        try {

            // Buscar en HubSpot (tabla superior)
            setBaja(false);
            let hsResults = await SearchService.searchAllV2(searchParams.data, searchParams.searchType);

            if (!isNaN(hsResults) && !isNaN(parseFloat(hsResults)) && hsResults === 401) {
                return;
            }
            // Buscar contratos (lado izquierdo de la pantalla)
            if (searchParams.searchType != "RUT/Pasaporte" && hsResults.length > 0) {
                identifierValue = hsResults[0].properties?.rut || identifierValue
            }
            const updatedCriterios = { ...searchCriteria, Identifier: identifierValue };
            console.log(updatedCriterios)
            setSearchCriteria(updatedCriterios);

            await handleSearchContracts(updatedCriterios);



            if (hsResults?.bloqueoManager === true) {
                Swal.fire({ icon: 'error', title: 'Bloqueo por Baja', text: 'No puede continuar con la entrevista.', confirmButtonText: 'Aceptar' });
                setHubspotResults([]);
                setBaja(true);
                return;
            }

            if (hsResults == null) {
                Swal.fire({ position: "center", icon: "error", title: "No hay coincidencias, eliga otro metodo de busqueda.", showConfirmButton: false, timer: 4500 });
                setHubspotResults([]);
                return;
            }

            setHubspotResults(hsResults);
        } catch (error) {
            console.error('Error al buscar:', error);
            setError('Error al realizar la búsqueda: ' + error.message);
        } finally {
            setLoading(false);
            setSearching(false); // ⬅️ vuelve el botón a su icono original
        }
    };

    const handleSubmitNuevaEntrevista = (typeContract, negocio) => async (data) => {
        if (selectedRow == null) {
            Swal.fire({
                icon: "error",
                title: "No selecciono cliente",
            });
            return;
        }

        const cliente = hubspotResults.find(item => item.id == selectedRow);

        if (cliente.associations == null) {
            Swal.fire({
                icon: "error",
                title: "Cliente seleccionado no tiene negocio",
            });
            return;
        }

        const payload = {
            ContactId: cliente.id,        // viene de hubspot
            BussinessLineId: negocio.id,  // línea de negocio
            typeContract,   // contrato = false, anexo = true
            CreateById: usuarioSolicitante, // tu consultor logeado
        };

        const exito = await dispatch(
            setCrearHojaEntrevista("Entrevista", "post", payload)
        );

        if (exito) {
            Swal.fire({ icon: "success", title: "Entrevista creada" });
            navigate('/ContratoPage');
        }
    };



    const verifyRut = async (HubspotId, rut) => {
        let validRut = (rut == null || rut == undefined) ? false : ValidarRut(rut)
        while (!validRut) {
            const { value, isConfirmed, isDismissed } = await Swal.fire({
                title: 'El contacto seleccionado no tiene RUT',
                input: 'text',
                inputLabel: 'Por favor ingresa el RUT del contacto:',
                inputPlaceholder: 'Escribe aquí...',
                showCancelButton: true,
            });

            // Si el usuario cancela, salir del bucle
            if (isDismissed) return false;
            validRut = ValidarRut(value);
            if (!validRut) {
                await Swal.fire({
                    icon: 'error',
                    title: 'RUT inválido',
                    text: 'Por favor, intenta nuevamente.',
                    confirmButtonText: 'Reintentar',
                });
            } else {
                var ok = await SearchService.updateCustomer(HubspotId, validRut)
                if (ok) {
                    await handleSearchB();
                    return true;
                }
                else {
                    validRut = false
                }
            }
        }
        return true;
    };


    const OpenContactHb = (id) => {
        const url = 'https://app.hubspot.com/contacts/43953580/record/0-1/';
        window.open(url + id, '_blank', 'noopener,noreferrer');
    };

    const OpenDealHb = (id) => {
        const url = 'https://app.hubspot.com/contacts/43953580/record/0-3/';
        window.open(url + id, '_blank', 'noopener,noreferrer');
    };

    // NUEVO: Manejo de Solicitud de Desbloqueo
    const handleUnlockRequest = async () => {
        const { rutPasaporte } = searchParams;
        if (!rutPasaporte) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Por favor, ingrese un RUT/Pasaporte para solicitar el desbloqueo.",
                showConfirmButton: false,
                timer: 4500,
            });
            return;
        }

        Swal.fire({
            title: 'Confirmar Solicitud de Desbloqueo',
            text: `¿Estás seguro de que quieres solicitar el desbloqueo para el RUT: ${rutPasaporte}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, solicitar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const solicitudData = {
                        rut: rutPasaporte,
                        fecha_solicitud: new Date().toISOString(),
                        usuario_solicitante: usuarioSolicitante,
                        accion: "pendiente"
                    };
                    await DesbloqueoService.unlockCustomer(solicitudData);

                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: 'Solicitud de Desbloqueo Enviada',
                        text: `Solicitud enviada para el RUT: ${rutPasaporte}`,
                        showConfirmButton: false,
                        timer: 4500,
                    });
                    setBaja(false);

                } catch (error) {
                    setError('Error al solicitar el desbloqueo.');
                    console.error('Error:', error);
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: 'Error al solicitar el desbloqueo.',
                        showConfirmButton: false,
                        timer: 4500,
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };


    // Estado para guardar la selección de contacto
    const [selectedRow, setSelectedRow] = useState(null);

    const handleCheckboxChange = async (rowId) => {
        const cliente = hubspotResults.find(item => item.id == rowId);
        var seguir = await verifyRut(rowId, cliente.properties.rut)
        if (seguir) {
            setSelectedRow(prev => (prev === rowId ? null : rowId)); // si ya está seleccionado, lo deselecciona
        } else
            setSelectedRow(null)
    };



    // NUEVO: Definición de columnas de DataTable
    const columnsSearch = [
        {
            name: 'Contacto HB',
            cell: row => row.data?.id ?
                <Button variant="outlined" size="small" sx={{ width: '125px' }} onClick={() => OpenContactHb(row.data.id)}>
                    {row.data.id}
                </Button>
                : "no tiene",
            sortable: true,
            width: '150px',
        },
        { name: 'RUT', cell: row => row.data?.properties?.rut || row.data?.cliente?.rut || 'no tiene', sortable: true, width: '120px' },
        { name: 'TELEFONO', cell: row => row.data?.properties?.phone || row.data?.cliente?.phone || '-', sortable: true, width: '150px' },
        { name: 'EMAIL', cell: row => row.data?.properties?.email || row.data?.cliente?.email || '-', sortable: true, width: '240px' },
        {
            name: 'NEGOCIO(s)',
            cell: row => {
                const negocios = row.data?.associations?.deals.results.map(deal => deal.id).join(',') || '';
                if (!negocios) return 'no tiene';
                return negocios.includes(',')
                    ? negocios
                    : <Button variant="outlined" size="small" sx={{ width: '125px' }} onClick={() => OpenDealHb(negocios)}>
                        {negocios}
                    </Button>;
            },
            sortable: true,
            width: '160px',
        },
        {
            name: 'SELECCIONAR',
            cell: row => (
                <Checkbox
                    checked={selectedRow === row.data?.id}
                    onChange={() => handleCheckboxChange(row.data?.id)}
                    color="primary"
                />
            ),
            width: '120px',
            sortable: false,
        },
    ];


    const handleClear = () => {
        setSearchParams({ rutPasaporte: '', email: '', searchType: 'RUT/Pasaporte', entityType: '', data: '' });
        setHubspotResults([]);
        setError(null);
        setBaja(false);
        setSelectedNegocio('');
        sessionStorage.removeItem("selectedNegocio");
    };

    const handleInputChange = (e) => {
        setSearchParams(prev => ({ ...prev, data: e.target.value.trim(), rutPasaporte: e.target.value.trim() }));
        setBaja(false);
    };


    const HandleOpenCtto = (row) => {
        const id = row.customerInterviewId;

        // Guardar en sessionStorage
        sessionStorage.setItem("customerInterviewId", id);

        // Navegar
        navigate('/ContratoPage', { state: { customerInterviewId: id } });
    }



    const columns = [
        {
            name: 'Código contrato',
            selector: row =>
                row?.codCtto && String(row.codCtto).trim() !== ''
                    ? row.codCtto
                    : 'ENTREVISTA_EN_CURSO',
            sortable: true,
            width: "240px",
            cell: row => (
                <span style={{ cursor: "default" }}>
                    {row?.codCtto && String(row.codCtto).trim() !== ''
                        ? row.codCtto
                        : 'ENTREVISTA_EN_CURSO'}
                </span>
            ),
        },

        // {
        //     name: 'Negocio',
        //     selector: row => (row.lineOfBusiness ? row.lineOfBusiness.split(' ').slice(1).join(' ') : ''),
        //     sortable: true,
        //     width: "100px",
        // },
        // {
        //     name: 'Rut',
        //     selector: row => row.identifier,
        //     sortable: true,
        //     width: "auto",
        //     width: "106px",
        // },
        {
            name: 'Defendido',
            selector: row => row.name,
            sortable: true,
            width: "190px"//,
        },
        // {
        //     name: 'ContractId',
        //     selector: row => row.contractId,
        //     sortable: true,
        //     width: "190px"//,
        // },
        // {
        //     name: 'Firmado',
        //     selector: row => row.confirmationDate ? new Date(row.confirmationDate) : null,
        //     format: row => row.confirmationDate ? moment(row.confirmationDate).format("DD/MM/YYYY") : "NO",
        //     sortable: true,
        //     width: "105px",
        // },
        // {
        //     name: 'Validado',
        //     selector: row => row.validationDate ? new Date(row.validationDate) : null,
        //     format: row => row.validationDate ? moment(row.validationDate).format("DD/MM/YYYY") : "NO",
        //     sortable: true,
        //     width: "105px",
        // },
        {
            name: 'Atendido Por',
            selector: row => row.atendidoPor,
            sortable: true,
            width: "140px",
        },
        {
            name: 'Monto',
            selector: row => formatToCLP(row.monto ?? 0),
            sortable: true,
            width: "110px",
        },
        {
            name: 'Creado',
            selector: row => row.createAt ? new Date(row.createAt) : null,
            format: row => moment(row.createAt).format("DD/MM/YYYY"),
            sortable: true,
            width: "105px",
        },
        // {
        //     name: 'Estado',
        //     selector: row => row.statusContract,
        //     sortable: true,
        //     width: "182px",
        // },
        {
            name: 'Acciones',
            selector: row => row.codCtto,
            sortable: true,
            width: "240px",
            cell: row => {
                const firmado = row.confirmationDate
                    ? moment(row.confirmationDate).format("DD/MM/YYYY")
                    : "NO";
                //Comentado por SAm, se debe  quitar || true , es solo prueba temporal para finiquitar contrato
                return (firmado === "NO" && firmado !== null) ? (
                    <Button
                        className='p-1'
                        style={{ width: "230px" }}
                        variant='outlined'
                        onClick={() => HandleOpenCtto(row)}
                    >
                        Continuar Entrevista
                    </Button>
                ) : null;
            },
        }

    ];

    const [searchCriteria, setSearchCriteria] = useState({
        Desde: null,
        Hasta: null,
        Identifier: null,
        LineNegocio: null,
        Validado: null,
        NoValidado: null,
        Confirmado: null,
        NoConfirmado: null,
        Cancelado: null,
        Finiquitado: null,
        //Estado: ''
    });


    const [filteredItems, setFilteredItems] = useState([]); // Datos filtrados para la tabla
    const [myAccountData, setMyAccountData] = useState(null);


    const handleSearchContracts = async (criteria) => {
        dispatch(resetTabState());
        setLoading(true);

        var auxForm = { ...criteria }; // usar lo que le pasamos
        for (var propName in auxForm)
            if (auxForm[propName] === null || auxForm[propName] === undefined || auxForm[propName] === "") delete auxForm[propName];

        await setTimeout(async () => {
            const contratos = await LobService.getSearchInterviewV2(auxForm);
            setFilteredItems(contratos);
            setLoading(false);
        }, 300);
    };



    return (
        <Container maxWidth="lg">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h5" sx={{ mb: 4 }}>
                    Búsqueda de Cliente / Entrevista
                </Typography>
                <div className="apple-container">
                    <Box sx={{ p: 4, maxWidth: "1200px", margin: "0 auto" }}>
                        <Paper sx={{ p: 2, mb: 2 }} className="apple-card">
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <TextField
                                    name="rutPasaporte"
                                    label={searchParams.searchType}
                                    variant="outlined"
                                    size="small"
                                    value={searchParams.data.trim()}
                                    onChange={handleInputChange}
                                    fullWidth
                                />
                                <Select
                                    labelId="BuscarPor"
                                    id="BuscarPor"
                                    value={searchParams.searchType}
                                    label="Buscar Por"
                                    onChange={(e) =>
                                        setSearchParams((prev) => ({
                                            ...prev,
                                            searchType: e.target.value,
                                        }))
                                    }
                                    sx={{ height: 40 }}
                                >
                                    <MenuItem value={"RUT/Pasaporte"}>RUT</MenuItem>
                                    <MenuItem value={"Correo"}>Correo</MenuItem>
                                    <MenuItem value={"Id Contacto"}>Id Contacto</MenuItem>
                                    <MenuItem value={"Id Negocio"}>Id Negocio</MenuItem>
                                </Select>
                            </Box>

                            <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={searching ? <HourglassTopTwoToneIcon /> : <PersonSearchIcon />}
                                    onClick={handleSearchB}
                                    disabled={loading || searching}
                                >
                                    {searching ? 'Buscando…' : 'Buscar'}
                                </Button>

                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    startIcon={<ClearIcon />}
                                    onClick={handleClear}
                                    disabled={loading}
                                >
                                    Limpiar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="info"
                                    startIcon={<LockOpenIcon />}
                                    onClick={handleUnlockRequest}
                                    disabled={loading || !baja}
                                >
                                    Solicitar Desbloqueo
                                </Button>
                            </Box>
                        </Paper>


                        {loading && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <CircularProgress />
                            </Box>
                        )}



                        {!loading && hubspotResults && (
                            <>
                                <DataTable
                                    columns={columnsSearch}
                                    noDataComponent={loading || searching ? null : "No hay datos disponibles"}
                                    // progressPending={loading || searching}
                                    customStyles={customStyles}
                                    data={Object.entries(hubspotResults).map(([system, data]) => ({
                                        system,
                                        found: !!data,
                                        data: data || {},
                                    }))}
                                />


                                {negocioList.length > 0 && hubspotResults[0] && (
                                    <Box sx={{ mt: 4 }}>
                                        {negocioList.map((negocio) => {
                                            const contratosNegocio = filteredItems.filter(
                                                (item) => item.lineOfBusinessId === negocio.id
                                            );

                                            return (
                                                <Paper key={negocio.id} sx={{ mb: 3, p: 2 }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ fontWeight: "bold" }}
                                                        >
                                                            {negocio.name}
                                                        </Typography>

                                                        <Box sx={{ display: "flex", gap: 1 }}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                size="small"
                                                                onClick={handleSubmitNuevaEntrevista(contratosNegocio.length === 0, negocio)}>
                                                                {contratosNegocio.length === 0 ? "Iniciar Entrevista" : "Crear Anexo"}
                                                            </Button>
                                                        </Box>
                                                    </Box>

                                                    {contratosNegocio.length > 0 && (
                                                        <DataTable
                                                            columns={columns}
                                                            data={contratosNegocio}
                                                            progressPending={loading}
                                                            pagination
                                                            paginationPerPage={20}
                                                            paginationRowsPerPageOptions={[20, 30, 50, 100, 200,]}
                                                            customStyles={customStyles}
                                                            noDataComponent="No hay contratos para este negocio"
                                                        />
                                                    )}
                                                </Paper>
                                            );
                                        })}
                                    </Box>
                                )}
                            </>
                        )}
                    </Box>
                    <footer>
                        <p>
                            © {today.getFullYear()} Generador de Contratos v2.0.1. Todos los
                            derechos reservados Grupo Defensa. Desarrollado por Gerencia TI
                        </p>
                    </footer>
                </div>
            </Paper>
        </Container>
    )
}


const customStyles = {
    table: { style: { minWidth: '100%', }, },
    headRow: {
        style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            color: '#1D1D1F',
        },
    },
};
// Estilos del Modal
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 1,
    boxShadow: 24,
    p: 4,
};

export default ClientesBusqueda;
